module.exports = __webpack_public_path__ + "static/exterior-3-1b04ded860abfc827ffd85749b617fcf.jpg";